import axios, { AxiosRequestHeaders } from "axios";
import keycloak from "./keycloak";

const axiosApiInstance = axios.create({
  baseURL: window.__env__.AGORIA_BACK_URL,
});

axiosApiInstance.interceptors.request.use(
  async (config) => {
    const token = keycloak?.token;
    const { Authorization, ...rest } = config.headers as AxiosRequestHeaders & {
      Authorization: string;
    };
    config.headers = {
      Authorization: `Bearer ${token}`,
      ...rest,
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

export default axiosApiInstance;
